import * as React from 'react';
import { Card, Button } from '@grandvisionhq/common';
import { useLink } from '@grandvisionhq/frk-routing';
import { useIntl } from '@grandvisionhq/state';
import { pushTryOnInStoreEvent } from '../../../data-layer/try-on-in-store.js';

const AddProduct = ()=>{
    const { getLabel  } = useIntl();
    const { href , onClick  } = useLink({
        route: 'products.list',
        params: {
            type: 'sunglasses',
            facetQueryParams: {
                isReservable: true
            }
        }
    }) || {};
    const onHandleClick = ()=>{
        pushTryOnInStoreEvent({
            interactionType: 'add_more_products'
        });
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    return /*#__PURE__*/ React.createElement(Card, {
        className: "try-in-store-selection-modal__add-product"
    }, /*#__PURE__*/ React.createElement(Button, {
        icon: "plus",
        variant: "ghost",
        caption: getLabel('tryInStore.component.selectionModal.addProductButton'),
        className: "try-in-store-selection-modal__add-product__button",
        href: href,
        onClick: onHandleClick
    }));
};

export { AddProduct };
//# sourceMappingURL=AddProduct.js.map
